var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 34,
    viewBox: "0 0 31 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9992 24.4608V28.977C29.0007 29.3962 28.9233 29.8112 28.7718 30.1954C28.6203 30.5795 28.3982 30.9243 28.1196 31.2078C27.841 31.4912 27.5121 31.707 27.1539 31.8413C26.7958 31.9756 26.4162 32.0255 26.0397 31.9878C21.8623 31.4844 17.8496 29.9015 14.324 27.3662C11.0439 25.0549 8.263 21.9711 6.17871 18.3338C3.88441 14.4065 2.45663 9.93512 2.01102 5.28192C1.97709 4.86563 2.02171 4.44607 2.14202 4.04994C2.26234 3.65381 2.45571 3.28981 2.70984 2.9811C2.96397 2.67239 3.27328 2.42574 3.61808 2.25685C3.96288 2.08796 4.33561 2.00054 4.71255 2.00015H8.78521C9.44404 1.99296 10.0827 2.25167 10.5823 2.72806C11.0818 3.20445 11.4081 3.86601 11.5003 4.58944C11.6722 6.03473 11.991 7.45381 12.4506 8.81962C12.6332 9.35844 12.6728 9.94403 12.5645 10.507C12.4562 11.07 12.2047 11.5867 11.8397 11.996L10.1156 13.9079C12.0482 17.6767 14.8622 20.7973 18.2609 22.9403L19.985 21.0284C20.3541 20.6237 20.8201 20.3448 21.3278 20.2247C21.8355 20.1046 22.3636 20.1485 22.8495 20.351C24.0811 20.8607 25.3608 21.2142 26.6642 21.4048C27.3236 21.508 27.9259 21.8763 28.3564 22.4398C28.7869 23.0032 29.0157 23.7225 28.9992 24.4608Z",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.acd4f90b6494994f78be13721b0f4b36.svg";
export { ForwardRef as ReactComponent };